//! @ngInject
export function FilterUtils($rootScope) {
  const rootFilters = {};

  return {
    rootFilters: rootFilters,
  };
};
